
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.08 22.54c0 12.45-10.092 22.543-22.543 22.543S-.006 34.99-.006 22.54 10.087-.002 22.537-.002 45.08 10.09 45.08 22.54","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M34.67 17.93c-.065 0-.128.007-.193.01a7.531 7.531 0 00.193-1.673 7.54 7.54 0 00-7.54-7.54c-2.15 0-4.086.905-5.46 2.348a7.511 7.511 0 00-5.458-2.348 7.54 7.54 0 00-7.54 7.54c0 .655.092 1.288.25 1.895a4.945 4.945 0 001.496 9.655H34.67a4.943 4.943 0 100-9.887","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.04 19.27l-4.462 5.333h1.775l.819 8.37h3.737l.818-8.37h1.775z","fill":"#84dbff"}}),_c('path',{attrs:{"d":"M28.04 36.36l4.462-5.334h-1.775l-.819-8.37h-3.737l-.818 8.37h-1.775z","fill":"#ff7058"}})])
          )
        }
      }
    